import { Localization } from 'connex-cds';
import React from 'react';
import { useGetCompanyAdmin } from '../../../../query-hooks/company';

export const useMonitorTimeZone = () => {
  const { setTimeZone } = Localization.useLocalizationContext();
  const { data, isLoading } = useGetCompanyAdmin();

  React.useEffect(() => {
    if (!isLoading) {
      setTimeZone(data?.dateTimeSettings?.timeZone);
    }
  }, [isLoading, data?.dateTimeSettings?.timeZone, setTimeZone]);

  return {};
};
